import { P } from "./P.styles";

export default P;
